import Features from './features'

export default Features
